import classNames from 'classnames';
import * as React from 'react';
import './Tab.css';
import TabProps from './TabProps';

interface Props {
    props: TabProps;
    isSelected: boolean;
    onClick: (id: string) => void;
}

const Tab: React.FunctionComponent<Props> = props => {
    const classes = classNames(['Tab', { 'Tab_Selected': props.isSelected }]);
    const onClick = () => props.onClick(props.props.id);

    return (
        <div className={classes} onClick={onClick}>
            {props.props.icon && <div className="Tab_Icon material-icons">{props.props.icon}</div>}
            <div className="Tab_Title">{props.props.title}</div>
        </div>
    );
};

export default Tab;
